import { render, staticRenderFns } from "./ReportListPage.vue?vue&type=template&id=210acef4&"
import script from "./ReportListPage.vue?vue&type=script&lang=js&"
export * from "./ReportListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports